export default __webpack_public_path__ + "locales/ru/PaymentsEnterprise.json?hash=7d2a033bf6ba8813e29fc5eb1a801c1d";